<template>
  <b-modal
    :id="modalId"
    centered
    no-close-on-backdrop
    no-close-on-esc
    :hide-header-close="isRetryLimitReached"
    title="Disbursement Belum Berhasil"
  >
    <b-alert show variant="warning" class="mb-3">
      <strong>Dana belum berhasil dikirim.</strong>
      <div v-if="isRetryLimitReached">
        Batas percobaan ulang sudah tercapai.<br />
        Silakan ubah pencairan ke tunai.
      </div>
      <div v-else>Transaksi aman untuk dicoba ulang.</div>
    </b-alert>

    <p class="mb-2">
      Percobaan: {{ retryCount }} dari {{ maxRetry }}
    </p>
    <p v-if="showCountdown" class="mb-0 text-muted">
      Coba kembali tersedia dalam {{ countdown }} detik.
    </p>

    <template v-slot:modal-footer>
      <b-button
        variant="outline-danger"
        :disabled="isSubmitting"
        @click="$emit('switch-to-cash')"
      >
        Ubah ke Tunai
      </b-button>
      <b-button
        v-if="!isRetryLimitReached"
        variant="pgiBtn"
        :disabled="countdown > 0 || isSubmitting"
        @click="$emit('retry')"
      >
        <b-spinner small type="grow" v-if="isSubmitting"></b-spinner>
        {{ retryButtonLabel }}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: "modal-disbursement-retry",
  props: {
    modalId: {
      type: String,
      default: "modal-safe-to-retry",
    },
    retryCount: {
      type: Number,
      required: true,
    },
    maxRetry: {
      type: Number,
      required: true,
    },
    countdown: {
      type: Number,
      required: true,
    },
    isSubmitting: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isRetryLimitReached() {
      return this.retryCount >= this.maxRetry;
    },
    showCountdown() {
      return !this.isRetryLimitReached && this.countdown > 0;
    },
    retryButtonLabel() {
      if (this.countdown > 0) {
        return `Coba Lagi (${this.countdown} detik)`;
      }

      return "Coba Lagi";
    },
  },
};
</script>
